/*
  ZUCK-BF 2026-10-30 — camada da Black Friday (draft "Black Friday 2026 — visual (Zuck)").
  Unico trabalho: a linha "Economize R$ X" dos cards (renderizada no Liquid) acompanha o preco
  quando a cliente troca a cor no card (ProductCardPricing repinta o preco, nao a economia).
  Le exatamente o que esta na tela: preco riscado - preco atual. Sem desconto => linha some.
*/
(function () {
  if (window.__zuckBf) return;
  window.__zuckBf = true;

  function cents(text) {
    var digits = String(text || '').replace(/[^\d,]/g, '').replace(',', '.');
    var value = parseFloat(digits);
    return isFinite(value) ? Math.round(value * 100) : 0;
  }

  function money(c) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(c / 100).replace(/ /g, ' ');
  }

  function syncBox(box) {
    var oldEl = box.querySelector('.price-old');
    var mainEl = box.querySelector('.price-main');
    var save = box.querySelector('[data-zbf-save]');
    if (!mainEl) return;
    var diff = oldEl && !oldEl.classList.contains('hidden') ? cents(oldEl.textContent) - cents(mainEl.textContent) : 0;
    var perUnit = Boolean(box.querySelector('.price-per-unit-suffix'));
    if (diff <= 0) {
      if (save) save.hidden = true;
      return;
    }
    if (!save) {
      save = document.createElement('div');
      save.className = 'zbf-save';
      save.setAttribute('data-zbf-save', '');
      var line = box.querySelector('.price-main-line');
      if (line) line.after(save);
      else box.appendChild(save);
    }
    var text = 'Economize ' + money(diff) + (perUnit ? '/cada' : '');
    if (save.textContent !== text) save.textContent = text;
    save.hidden = false;
  }

  // ZUCK-BF-RIBBON 2026-11-01: a faixa rolante (logo depois de cada selo % OFF) segue o selo:
  // qualquer desconto (> 0%) = faixa visivel com o mesmo texto, selo so para leitor de tela; senao selo normal.
  function syncRibbons(card) {
    var any = false;
    card.querySelectorAll('.product-badge-discount').forEach(function (badge) {
      var rb = badge.nextElementSibling;
      if (!rb || !rb.hasAttribute('data-zbf-ribbon')) return;
      var pct = parseInt(String(badge.textContent).replace(/[^\d]/g, ''), 10) || 0;
      var on = pct > 0 && !badge.classList.contains('hidden');
      badge.classList.toggle('zbf-rb-badge', on);
      rb.hidden = !on;
      if (on) {
        var text = pct + '% OFF';
        rb.querySelectorAll('span').forEach(function (sp) {
          if (sp.textContent !== text) sp.textContent = text;
        });
      }
    });
    card.querySelectorAll('[data-zbf-ribbon]').forEach(function (rb) {
      if (rb.offsetParent || rb.getClientRects().length) any = true;
    });
    var inner = card.querySelector('.card__inner');
    if (inner) inner.classList.toggle('zbf-rb-none', !any);
  }

  function syncAllRibbons(root) {
    (root || document).querySelectorAll('.card__inner [data-zbf-ribbon]').forEach(function (rb) {
      var card = rb.closest('.product-card-wrapper') || rb.closest('.card-wrapper');
      if (card && !card.__zbfRb) {
        card.__zbfRb = true;
        syncRibbons(card);
      }
    });
  }

  function syncCard(card) {
    if (!card) return;
    card.querySelectorAll('.custom-card-price').forEach(syncBox);
    syncRibbons(card);
  }

  function boot() {
    syncAllRibbons(document);
    // cards que chegam depois (filtros, carrosseis, LP Black): sincroniza uma vez cada
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { syncAllRibbons(document); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener(
    'click',
    function (event) {
      var dot = event.target.closest && event.target.closest('.card-product-swatch-btn');
      if (!dot) return;
      var card = dot.closest('.product-card-wrapper') || dot.closest('.card-wrapper');
      setTimeout(function () {
        syncCard(card);
      }, 0);
    },
    true
  );
})();
